import React from 'react';
import { DocsLayout } from '../../components/docs/DocsLayout';
import { CodeBlock } from '../../components/docs/CodeBlock';
import { Callout } from '../../components/docs/Callout';
export function PaymentsAPIPage() {
  const createPayoutCode = {
    curl: `curl -X POST "https://api.obseq.com/v1/payments/payouts" \\
  -H "Authorization: Bearer $OBSEQ_API_KEY" \\
  -H "Content-Type: application/json" \\
  -H "Idempotency-Key: 9b7a8b2c-7f5f-4b3f-8c4b-2cf3b8f9f111" \\
  -d '{
    "amount": 250000,
    "currency": "USD",
    "beneficiary_id": "bn_01J9Z9GJ9Q2TQW3R4E5Y6U7I8O",
    "purpose": "supplier_payment",
    "metadata": {"invoice_id":"INV-10291"}
  }'`,
    node: `import fetch from "node-fetch";

const res = await fetch("https://api.obseq.com/v1/payments/payouts", {
  method: "POST",
  headers: {
    "Authorization": \`Bearer \${process.env.OBSEQ_API_KEY}\`,
    "Content-Type": "application/json",
    "Idempotency-Key": "9b7a8b2c-7f5f-4b3f-8c4b-2cf3b8f9f111"
  },
  body: JSON.stringify({
    amount: 250000,
    currency: "USD",
    beneficiary_id: "bn_01J9Z9GJ9Q2TQW3R4E5Y6U7I8O",
    purpose: "supplier_payment",
    metadata: { invoice_id: "INV-10291" }
  })
});

const data = await res.json();
console.log(data);`,
    python: `import os, requests, uuid

r = requests.post(
  "https://api.obseq.com/v1/payments/payouts",
  headers={
    "Authorization": f"Bearer {os.environ['OBSEQ_API_KEY']}",
    "Content-Type": "application/json",
    "Idempotency-Key": str(uuid.uuid4())
  },
  json={
    "amount": 250000,
    "currency": "USD",
    "beneficiary_id": "bn_01J9Z9GJ9Q2TQW3R4E5Y6U7I8O",
    "purpose": "supplier_payment",
    "metadata": {"invoice_id":"INV-10291"}
  }
)
print(r.status_code, r.json())`,
    go: `package main

import (
    "bytes"
    "encoding/json"
    "net/http"
    "os"
)

func main() {
    payload := map[string]interface{}{
        "amount": 250000,
        "currency": "USD",
        "beneficiary_id": "bn_01J9Z9GJ9Q2TQW3R4E5Y6U7I8O",
        "purpose": "supplier_payment",
        "metadata": map[string]string{"invoice_id": "INV-10291"},
    }
    
    body, _ := json.Marshal(payload)
    req, _ := http.NewRequest("POST", "https://api.obseq.com/v1/payments/payouts", bytes.NewBuffer(body))
    req.Header.Set("Authorization", "Bearer "+os.Getenv("OBSEQ_API_KEY"))
    req.Header.Set("Content-Type", "application/json")
    req.Header.Set("Idempotency-Key", "9b7a8b2c-7f5f-4b3f-8c4b-2cf3b8f9f111")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
}`
  };
  return <DocsLayout breadcrumbs={[{
    label: 'Docs',
    href: '/docs'
  }, {
    label: 'API Reference',
    href: '/docs/api-reference'
  }, {
    label: 'Payments',
    href: '/docs/api-reference/payments'
  }]} onThisPage={[{
    title: 'Overview',
    id: 'overview'
  }, {
    title: 'Endpoints',
    id: 'endpoints'
  }, {
    title: 'Create Payout',
    id: 'create-payout'
  }, {
    title: 'Retrieve Payout',
    id: 'retrieve-payout'
  }, {
    title: 'List Payouts',
    id: 'list-payouts'
  }, {
    title: 'Webhooks',
    id: 'webhooks'
  }, {
    title: 'Errors',
    id: 'errors'
  }]} data-id="element-1896">
      <h1 data-id="element-1897">Payments API</h1>
      <p className="lead" data-id="element-1898">
        The Payments API provides collections (money in) and payouts (money out)
        via local rails and cross-border settlement.
      </p>

      <h2 id="overview" data-id="element-1899">Overview</h2>
      <p data-id="element-1900">Payments supports:</p>
      <ul data-id="element-1901">
        <li data-id="element-1902">
          <strong data-id="element-1903">Collections:</strong> Receive money from customers via local
          payment methods
        </li>
        <li data-id="element-1904">
          <strong data-id="element-1905">Payouts:</strong> Send money to beneficiaries globally
        </li>
        <li data-id="element-1906">
          <strong data-id="element-1907">Beneficiaries:</strong> Store and manage payout destinations
        </li>
        <li data-id="element-1908">
          <strong data-id="element-1909">Rails:</strong> Query supported payment rails by country and
          currency
        </li>
      </ul>

      <h2 id="endpoints" data-id="element-1910">Endpoints</h2>

      <h3 data-id="element-1911">Rails</h3>
      <ul className="space-y-2" data-id="element-1912">
        <li data-id="element-1913">
          <code className="text-sm" data-id="element-1914">GET /v1/payments/rails</code> - List
          supported rails
        </li>
      </ul>

      <h3 data-id="element-1915">Beneficiaries</h3>
      <ul className="space-y-2" data-id="element-1916">
        <li data-id="element-1917">
          <code className="text-sm" data-id="element-1918">POST /v1/payments/beneficiaries</code> -
          Create beneficiary
        </li>
        <li data-id="element-1919">
          <code className="text-sm" data-id="element-1920">GET /v1/payments/beneficiaries/:id</code> -
          Retrieve beneficiary
        </li>
        <li data-id="element-1921">
          <code className="text-sm" data-id="element-1922">GET /v1/payments/beneficiaries</code> - List
          beneficiaries
        </li>
      </ul>

      <h3 data-id="element-1923">Collections</h3>
      <ul className="space-y-2" data-id="element-1924">
        <li data-id="element-1925">
          <code className="text-sm" data-id="element-1926">POST /v1/payments/collections</code> -
          Create collection
        </li>
        <li data-id="element-1927">
          <code className="text-sm" data-id="element-1928">GET /v1/payments/collections/:id</code> -
          Retrieve collection
        </li>
        <li data-id="element-1929">
          <code className="text-sm" data-id="element-1930">GET /v1/payments/collections</code> - List
          collections
        </li>
        <li data-id="element-1931">
          <code className="text-sm" data-id="element-1932">
            POST /v1/payments/collections/:id/cancel
          </code>{' '}
          - Cancel collection
        </li>
      </ul>

      <h3 data-id="element-1933">Payouts</h3>
      <ul className="space-y-2" data-id="element-1934">
        <li data-id="element-1935">
          <code className="text-sm" data-id="element-1936">POST /v1/payments/payouts</code> - Create
          payout
        </li>
        <li data-id="element-1937">
          <code className="text-sm" data-id="element-1938">GET /v1/payments/payouts/:id</code> -
          Retrieve payout
        </li>
        <li data-id="element-1939">
          <code className="text-sm" data-id="element-1940">GET /v1/payments/payouts</code> - List
          payouts
        </li>
        <li data-id="element-1941">
          <code className="text-sm" data-id="element-1942">POST /v1/payments/payouts/:id/retry</code> -
          Retry failed payout
        </li>
      </ul>

      <h3 data-id="element-1943">Reconciliation</h3>
      <ul className="space-y-2" data-id="element-1944">
        <li data-id="element-1945">
          <code className="text-sm" data-id="element-1946">GET /v1/payments/payouts/:id/receipt</code>{' '}
          - Get payout receipt
        </li>
      </ul>

      <h2 id="create-payout" data-id="element-1947">Create Payout</h2>
      <p data-id="element-1948">Creates a new payout to send money to a beneficiary.</p>

      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 my-4" data-id="element-1949">
        <code className="text-sm font-semibold" data-id="element-1950">POST /v1/payments/payouts</code>
      </div>

      <h3 data-id="element-1951">Parameters</h3>
      <table className="w-full text-sm my-4" data-id="element-1952">
        <thead data-id="element-1953">
          <tr className="border-b border-slate-200" data-id="element-1954">
            <th className="text-left py-2 pr-4" data-id="element-1955">Parameter</th>
            <th className="text-left py-2 pr-4" data-id="element-1956">Type</th>
            <th className="text-left py-2" data-id="element-1957">Description</th>
          </tr>
        </thead>
        <tbody data-id="element-1958">
          <tr className="border-b border-slate-100" data-id="element-1959">
            <td className="py-2 pr-4" data-id="element-1960">
              <code data-id="element-1961">amount</code>
            </td>
            <td className="py-2 pr-4" data-id="element-1962">integer</td>
            <td className="py-2" data-id="element-1963">
              Amount in smallest currency unit (e.g., cents)
            </td>
          </tr>
          <tr className="border-b border-slate-100" data-id="element-1964">
            <td className="py-2 pr-4" data-id="element-1965">
              <code data-id="element-1966">currency</code>
            </td>
            <td className="py-2 pr-4" data-id="element-1967">string</td>
            <td className="py-2" data-id="element-1968">Three-letter ISO currency code</td>
          </tr>
          <tr className="border-b border-slate-100" data-id="element-1969">
            <td className="py-2 pr-4" data-id="element-1970">
              <code data-id="element-1971">beneficiary_id</code>
            </td>
            <td className="py-2 pr-4" data-id="element-1972">string</td>
            <td className="py-2" data-id="element-1973">ID of the beneficiary to pay</td>
          </tr>
          <tr className="border-b border-slate-100" data-id="element-1974">
            <td className="py-2 pr-4" data-id="element-1975">
              <code data-id="element-1976">purpose</code>
            </td>
            <td className="py-2 pr-4" data-id="element-1977">string</td>
            <td className="py-2" data-id="element-1978">Payment purpose (e.g., "supplier_payment")</td>
          </tr>
          <tr className="border-b border-slate-100" data-id="element-1979">
            <td className="py-2 pr-4" data-id="element-1980">
              <code data-id="element-1981">metadata</code>
            </td>
            <td className="py-2 pr-4" data-id="element-1982">object</td>
            <td className="py-2" data-id="element-1983">Optional key-value pairs for reference</td>
          </tr>
        </tbody>
      </table>

      <h3 data-id="element-1984">Example Request</h3>
      <CodeBlock code={createPayoutCode} data-id="element-1985" />

      <h3 data-id="element-1986">Example Response</h3>
      <pre className="bg-slate-900 text-slate-100 p-4 rounded-lg overflow-x-auto my-4" data-id="element-1987">
        <code data-id="element-1988">{`{
  "id": "po_01J9Z98K5K8C0MZ9QK3G4B1E2P",
  "object": "payments.payout",
  "status": "pending",
  "amount": 250000,
  "currency": "USD",
  "beneficiary_id": "bn_01J9Z9GJ9Q2TQW3R4E5Y6U7I8O",
  "purpose": "supplier_payment",
  "created_at": "2026-01-03T18:41:22Z",
  "updated_at": "2026-01-03T18:41:22Z",
  "metadata": {
    "invoice_id": "INV-10291"
  }
}`}</code>
      </pre>

      <h2 id="retrieve-payout" data-id="element-1989">Retrieve Payout</h2>
      <p data-id="element-1990">Retrieves the details of an existing payout.</p>
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 my-4" data-id="element-1991">
        <code className="text-sm font-semibold" data-id="element-1992">
          GET /v1/payments/payouts/:id
        </code>
      </div>

      <h2 id="list-payouts" data-id="element-1993">List Payouts</h2>
      <p data-id="element-1994">Returns a list of payouts with cursor-based pagination.</p>
      <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 my-4" data-id="element-1995">
        <code className="text-sm font-semibold" data-id="element-1996">GET /v1/payments/payouts</code>
      </div>

      <h2 id="webhooks" data-id="element-1997">Webhook Events</h2>
      <p data-id="element-1998">The Payments API sends the following webhook events:</p>
      <ul data-id="element-1999">
        <li data-id="element-2000">
          <code data-id="element-2001">payments.collection.created</code> - Collection initiated
        </li>
        <li data-id="element-2002">
          <code data-id="element-2003">payments.collection.succeeded</code> - Collection completed
          successfully
        </li>
        <li data-id="element-2004">
          <code data-id="element-2005">payments.collection.failed</code> - Collection failed
        </li>
        <li data-id="element-2006">
          <code data-id="element-2007">payments.payout.created</code> - Payout initiated
        </li>
        <li data-id="element-2008">
          <code data-id="element-2009">payments.payout.succeeded</code> - Payout completed successfully
        </li>
        <li data-id="element-2010">
          <code data-id="element-2011">payments.payout.failed</code> - Payout failed
        </li>
      </ul>

      <Callout type="note" data-id="element-2012">
        See the{' '}
        <a href="#/docs/guides/webhooks" className="text-blue-600 hover:text-blue-700" data-id="element-2013">
          Webhooks Guide
        </a>{' '}
        for setup and verification details.
      </Callout>

      <h2 id="errors" data-id="element-2014">Common Errors</h2>
      <ul data-id="element-2015">
        <li data-id="element-2016">
          <code data-id="element-2017">beneficiary_not_found</code> - Invalid beneficiary ID
        </li>
        <li data-id="element-2018">
          <code data-id="element-2019">insufficient_balance</code> - Not enough funds in wallet
        </li>
        <li data-id="element-2020">
          <code data-id="element-2021">invalid_currency</code> - Currency not supported for destination
        </li>
        <li data-id="element-2022">
          <code data-id="element-2023">compliance_blocked</code> - Transaction blocked by compliance
          rules
        </li>
      </ul>

      <div className="mt-12 pt-8 border-t border-slate-200" data-id="element-2024">
        <h3 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-2025">
          Related Guides
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2026">
          <a href="#/docs/guides/getting-started" className="p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-2027">
            <h4 className="font-semibold text-slate-900 mb-1" data-id="element-2028">
              Getting Started
            </h4>
            <p className="text-sm text-slate-600" data-id="element-2029">Make your first API call</p>
          </a>
          <a href="#/docs/guides/webhooks" className="p-4 bg-slate-50 border border-slate-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-2030">
            <h4 className="font-semibold text-slate-900 mb-1" data-id="element-2031">Webhooks</h4>
            <p className="text-sm text-slate-600" data-id="element-2032">Handle payment events</p>
          </a>
        </div>
      </div>
    </DocsLayout>;
}